import { getSUBFromJWT, getToken } from "@bluefalcon/utils-package";
import { BF_TOKEN } from "../constants/cookies.constants";

export const snakeCaseToReadable = (str: string): string => {
    return str
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

export const toUpperSnakeCase = (str: string): string => {
    return str
        .trim()
        .replace(/\s+/g, ' ')
        .replace(/\s/g, '_')
        .replace(/([a-z])([A-Z])/g, '$1_$2')
        .replace(/[^a-zA-Z0-9_]/g, '')
        .toUpperCase();
};

export const isAdmin = (): boolean => {
    return getSUBFromJWT(getToken(BF_TOKEN)!).includes('@bluefalcontech.com');
};

